module.exports = __webpack_public_path__ + "img/renxiang.e212ceb1.png";